import LangEnum from '../../../../../../../../lang/LangEnum';
import { useApplicationContext } from '../../../../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import ChatHeaderTemplate from '../../../../../ChatHeaderTemplate/ChatHeaderTemplate';

const ChatGroupedRoomsHeader = () => {
  const { translate } = useTranslation();

  const { state } = useApplicationContext();

  if (!state.user) {
    return null;
  }

  return (
    <ChatHeaderTemplate.Template>
      <ChatHeaderTemplate.Title text={translate(LangEnum.CHAT_ROOMS_HEADER_MESSAGE)} />
    </ChatHeaderTemplate.Template>
  );
};

export default ChatGroupedRoomsHeader;
